/**
 * The project's skills, reactive (RFC 0334 S4). The soul file and the
 * project's instructions are documents now, opened like any other (3g).
 *
 * Follows the World pointer as `useWorldSkills` and `useInstalledApps` do, and
 * takes the project doc from the caller, which already holds it. Registering a
 * skill, installing an app or editing either instruction rewrites one of the
 * two docs, so every surface reading this refreshes on its own.
 */

import type { AnyDocumentId } from '@automerge/automerge-repo/slim'
import { useMemo } from 'react'
import { useDocument } from '../world/repo/useDocument'
import { readWorldPointer } from '../world/world'
import { type ShownSkill, shownSkills } from './skillCatalog'

export interface ProjectSkills {
  skills: ShownSkill[]
  worldId: string | null
}

export function useSkills(projectDoc: unknown): ProjectSkills {
  const worldId = readWorldPointer()
  const [worldDoc] = useDocument((worldId ?? undefined) as AnyDocumentId)
  return useMemo(
    () => ({
      skills: shownSkills(worldDoc, projectDoc),
      worldId,
    }),
    [worldDoc, projectDoc, worldId],
  )
}
